import Container from "../ProductDetailsStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import * as utils from "../../../utils";
import api from "../../../services/api";
import AuthContext from "../../../contexts/authContext";
import VariationGroupsList from "./VariationProductsGroupsList";

import { useContext, useEffect, useState } from "react";
import InputCurrency from "../../../components/Buttons/InputCurrency";
import InfoModal from "../../../shared/Bootstrap/InfoModal";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import PageTitle from "../../../components/PageTitle";

export default function VariationProductsDetails(props) {

  const { userData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorEditing, setErrorEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [variationGroups, setVariationGroups] = useState([] as any);

  const [name, setName] = useState("");
  const [priceModification, setPriceModification] = useState("R$ 0,00");
  const [productCompanyId, setProductCompanyId] = useState(0);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [variationGroupToDelete, setVariationGroupToDelete] = useState({} as any);
  const [deletingVariationGroup, setDeletingVariationGroup] = useState(false);


  const productId = parseInt(props.match?.params?.productId);
  const variationId = parseInt(props.match?.params?.variationId) || 0;
  const creatingNew = variationId <= 0;

  useEffect(() => {
    if (!creatingNew)
      LoadVariation();
  }, []);

  async function LoadVariation() {
    try {
      setLoading(true);
      const result = await api.get(`products/${productId}/${variationId}`);
      if (result.data.success) {
        const variation = result.data.variationData;
        SetVariation(variation);
      }
      else
        console.error("Não pode pegar os dados da variação: ", result.data);
    }
    catch (error: any) {
      console.error("Erro pegando variação: ", error?.response?.data);
      setErrorEditing(true);
      setErrorMessage(error?.response?.data?.message || "Não foi possível carregar a variação");
    }
    finally {
      setLoading(false);
    }
  }

  function SetVariation(variation) {
    setName(variation.name);
    setPriceModification(utils.CentsToHuman(variation.priceModification));
    setProductCompanyId(variation.companyId);
    setVariationGroups(variation.variationGroups);
  }

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Variação de produto editada com sucesso!"
        body="Suas edições da variação do produto foram salvas com sucesso"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }

  function ShowConfirmDeletion() {
    return (
      <TwoButtonsModal
        show={variationGroupToDelete.id != null}
        onHide={ClosePopupDeletingVariationGroup}
        loading={deletingVariationGroup}
        title="Deleção de variação!"
        body={`Você está tentando deletar a variação "${variationGroupToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingVariationGroup}
        secondaryDisabled={deletingVariationGroup}
        primaryText="Deletar"
        primaryOnClick={DeleteVariationGroup}
        primaryDisabled={deletingVariationGroup}
      />
    )
  }

  function ClosePopupDeletingVariationGroup() {
    setVariationGroupToDelete({});
  }

  async function DeleteVariationGroup() {
    setDeletingVariationGroup(true);
    try {
      const result = await api.delete(`/products/${productId}/${variationId}/${variationGroupToDelete.id}`);
      if (!result.data.success) {
        setErrorMessage(result.data.message || "Não foi possível deletar grupo de variação")
        console.error("Não foi possível deletar variação", result.data);
      }
      else
        setErrorMessage("");
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Erro deletando grupo de variação");
      console.error("Erro deletando variação: ", error);
    }
    finally {
      await LoadVariation();
      setDeletingVariationGroup(false);
      ClosePopupDeletingVariationGroup();
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      const price = utils.CurrencyToCents(priceModification);
      const data = { name, priceModification: price };
      const request = await (creatingNew ? api.post(`/products/${productId}`, data) : api.put(`/products/${productId}/${variationId}`, data));

      setErrorEditing(false);
      setLoading(false);
      if (creatingNew && request.data.success)
        goBack();
      else if (request.data.success)
        setShowSuccessPopup(true);
    }
    catch (error: any) {
      setErrorEditing(true);
      setLoading(false);
      setErrorMessage(error?.response?.data?.message || "Não foi possível editar variação");
    }
  }

  function goBack() {
    props.history.goBack();
  }

  const disabled = loading || (productCompanyId !== userData.companyId && !creatingNew);

  return (
    <Container>
      <PageTitle title="Detalhes da Variação do Produto" />
      {ShowSuccessPopup()}
      {ShowConfirmDeletion()}
      <div className="productDetails">
        <div>
          <button onClick={() => goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorEditing && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" id="productDetailsForm" onSubmit={
              (e) => {
                e.preventDefault();
                OnSubmit();
              }}>
              <div id="header">
                <h2>{creatingNew ? "Criar" : "Editar"} variação de produto</h2>
              </div>
              <div>
                <label>Nome da variação:</label>
                <input

                  autoComplete="product-name"
                  disabled={disabled}
                  value={name || ""}
                  onChange={e => setName(e.target.value)}
                />
              </div>

              <InputCurrency
                label="Modificador de preço"
                id="priceModification"
                disabled={disabled}
                value={priceModification}
                OnChange={price => setPriceModification(price)}
                allowNegative={true}
              />

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={disabled}
                onClick={e => {
                  e.preventDefault();
                  OnSubmit();
                }}>{creatingNew ?
                  "Adicionar variação" :
                  "Editar variação"}
              </button>
            </form>
          </div>

          {!creatingNew &&
            <VariationGroupsList
              productId={productId}
              variationId={variationId}
              history={props.history}
              variationGroups={variationGroups}
              disabled={disabled}
              onClickDeleteVariationGroup={variationGroup => setVariationGroupToDelete(variationGroup)}
            />}
        </main>
      </div>
    </Container >
  );
}